import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../container/authContext';
import { getMyAccounts } from '../../services/company';
import { redirectToLibrary } from '../../utility';

// Shown after login to a person who has several accounts: one per facility they work in and
// one per company where they are a corporate system admin.
function SelectAccount() {
  const { switchAccount, logout } = useAuth();
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState(null);
  const [switchingTo, setSwitchingTo] = useState(null);
  const [error, setError] = useState(null);

  useLayoutEffect(() => {
    document.title = `AllCareForms`;
  });

  useEffect(() => {
    getMyAccounts()
      .then((res) => {
        if (res.length > 1) {
          setAccounts(res);
        } else {
          redirectToLibrary(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        redirectToLibrary(navigate);
      });
    // eslint-disable-next-line
  }, []);

  const selectAccount = async (account) => {
    if (switchingTo) return;

    setSwitchingTo(account.user_id);
    setError(null);
    try {
      await switchAccount(account.user_id);
    } catch (e) {
      console.log(e);
      setError('Could not open this account. Please try again.');
      setSwitchingTo(null);
    }
  };

  return (
    <>
      <header className="header-wrapper header-wrapper-login">
        <div className="header-left">
          <div className="header-logo">
            <img src="/images/logo.svg" alt="" />
          </div>
          <div className="pageBreadcrumbs">
            <span>Select Account</span>
          </div>
        </div>
      </header>
      <div className="login-page">
        <div className="login-page-wrapper login-padding">
          <div className="form-title">
            <h2>Select an account</h2>
            <p>You have several accounts. Choose the one you want to log in to.</p>
          </div>

          {accounts && (
            <ul className="account-list">
              {accounts.map((account) => (
                <li key={account.user_id}>
                  <button type="button" className="account-list-item" disabled={!!switchingTo} onClick={() => selectAccount(account)}>
                    <span className="account-list-company">{account.company_name}</span>
                    <span className="account-list-name">{account.name}</span>
                    {switchingTo === account.user_id && <span className="account-list-status">Opening...</span>}
                  </button>
                </li>
              ))}
            </ul>
          )}

          {error && <div className="form-error mt-1">{error}</div>}

          <div className="login-bottom login-bottom-center">
            <button type="button" className="btn-link" onClick={logout}>
              Log out
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default SelectAccount;
